import PropTypes from 'prop-types'
import { useAuth } from '../../hooks/auth/useAuth'
import ConsoleExporter from './ConsoleExporter'

/**
 * Conditional wrapper for ConsoleExporter
 * Shows the console exporter if:
 * - VITE_CONSOLE_CAPTURE_ENABLED is set to 'true' OR
 * - The logged-in user has admin level
 */
export const ConditionalConsoleExporter = (props) => {
  const { userLevel } = useAuth()

  // Show if environment variable is enabled OR user is admin
  const shouldShow =
    import.meta.env.VITE_CONSOLE_CAPTURE_ENABLED === 'true' || userLevel === 'admin'

  if (!shouldShow) {
    return null
  }

  return <ConsoleExporter {...props} />
}

ConditionalConsoleExporter.propTypes = {
  position: PropTypes.oneOf(['bottom-right', 'bottom-left', 'top-right', 'top-left']),
  showStats: PropTypes.bool,
}
